import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const api = axios.create({ baseURL: API_BASE_URL });

export interface CompatibilityCardData {
  sign_a: string;
  sign_b: string;
  family_pct: number;
  friendship_pct: number;
  overall_pct: number;
  sex_pct: number;
  love_pct: number;
  strengths: string[];
  weaknesses: string[];
  advice: string;
  // legado v1 — não é mais renderizado no card
  quote?: string | null;
  quote_author?: string | null;
  description?: string | null;
  perfect_date?: string | null;
}

export const compatibilityService = {
  async getCompatibility(signA: string, signB: string): Promise<CompatibilityCardData> {
    const r = await api.get(`/compatibility/${encodeURIComponent(signA)}/${encodeURIComponent(signB)}`);
    return r.data;
  },
};

export default compatibilityService;
